import axios from 'axios'

import { Controller } from "stimulus"
import { XhrLoadingAnimation } from "../../lib/xhr_loader"

/*
  Il y a un controller par widget, et chaque controller recoit les évènements du drag and drop

  Durant le drag and drop :
  - dragstart sur le widget d'origine
  - dragenter / dragleave sur chaque widget traversé (y compris le widget d'origine)
  - drop sur le widget sur lequel le widget d'origine a été relâché
  - dragend sur le widget d'origine

  Dans drop, le swap des éléments du dom provoque un connect() soit sur le widget d'origine soit sur le widget de réception (selon l'ordre d'insertion)
*/

export default class extends Controller {

  static targets = ["widgetBody", "foldLink"]
  static dragging_el = null // référence à l'élément qui est en cours de drag/drop
  static count // compteur sur les dragenter/dragleave pour ne changer le style du widget sous jacent qu'une fois (lorsque count revient à zéro)

  connect() {
    this.awaiting_response = false
    this.xhr_loading_animation = new XhrLoadingAnimation(this.widgetBodyTarget)

    if (this.element.dataset.fold === 'true') {
      this.load()
    }

    this.evtL1 = this.evtDragster.bind(this)
    this.events = ['dragstart', 'drag', 'dragenter', 'dragover', 'dragend', 'dragleave', 'drop']

    this.events.forEach((evt) => {
      this.element.addEventListener(evt, this.evtL1, false)
    })
  }

  disconnect() {
    this.events.forEach(evt => {
      this.element.removeEventListener(evt, this.evtL1, false)
    })
  }

  evtDragster(e) {
    var over_widget_el

    if (e.type != 'dragover')
      console.log(e.type, this.element.dataset.id, this.constructor.count)

    switch (e.type) {
      case 'dragstart':
        this.element.style.opacity = .5
        this.constructor.dragging_el = this.element
        this.constructor.count = 0
        e.dataTransfer.setData('text/plain', null)
        e.dataTransfer.effectAllowed = "move"
        //console.log(`${this.constructor.dragging_el.dataset.id} starts at ${this.constructor.dragSourceOffset}`)
        break

      case 'dragenter':
        over_widget_el = e.target.closest('.widget.droppable')
        if (over_widget_el != this.constructor.dragging_el) {
          this.constructor.count++
          if (this.constructor.count == 1) {
            //console.log(`${this.constructor.dragging_el.dataset.id} enters ${over_widget_el.dataset.id}`)
            this.element.querySelector('fieldset').style['background-color'] = '#ABCEE0'
          }
        }
        break

      case 'dragz':
        //console.log(e.screenY, window.innerHeight)
        if (e.screenY > window.innerHeight - 50) {
          //console.log('scroll')
          window.scrollBy(0, 1)
        }
        if (e.screenY < 50) {
          //console.log('scroll')
          window.scrollBy(0, -1)
        }
        e.preventDefault()
        break

      case 'dragover':
        e.preventDefault()
        break

      case 'dragleave':
        over_widget_el = e.target.closest('.widget.droppable')
        //console.log(`leave - over ${over_widget.dataset.id} - dragging is ${this.dragging_widget.dataset.id}`)
        if (over_widget_el != this.constructor.dragging_el) {
          this.constructor.count--
          if (this.constructor.count == 0) {
            console.log(`${this.constructor.dragging_el.dataset.id} leaves ${over_widget_el.dataset.id}`)
            this.element.querySelector('fieldset').style['background-color'] = '#ffffff'
          }
        }
        break

      case 'dragend':
        e.preventDefault()
        e.stopPropagation()
        this.element.style.opacity = 1
        this.constructor.dragging_el = null
        break

      case 'drop':
        e.preventDefault()
        //e.stopPropagation()
        this.element.querySelector('fieldset').style['background-color'] = '#ffffff'
        if (this.constructor.dragging_el.offsetTop > this.element.offsetTop)
          this.constructor.dragging_el.parentNode.insertBefore(this.constructor.dragging_el, this.element)
        else
          this.constructor.dragging_el.parentNode.insertBefore(this.element, this.constructor.dragging_el)
        this.save_positions()
        break
    }
  }

  save_positions() {
    var position = 1
    var positions = {}
    document.querySelector('#dashboard').querySelectorAll('.widget[draggable="true"').forEach(widget => {
      positions[widget.dataset.id] = position++
    })
    console.log(positions)
    axios.put('/widgets/save_positions.json', {
      positions: positions
    })
  }

  load() {
    this.widgetBodyTarget.innerHTML = ""
    this.xhr_loading_animation.start()
    this.awaiting_response = true
    axios.get(this.element.dataset.path)
      .then(response => {
        this.xhr_loading_animation.cancel()
        this.widgetBodyTarget.innerHTML = response.data
        this.awaiting_response = false
      })
      .catch((error) => {
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          //console.log(error.response.data)
          //console.log(error.response.status)
          //console.log(error.response.headers)
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          //console.log(error.request);
        } else {
          // Something happened in setting up the request and triggered an Error
          //console.log('Error', error.message);
        }
        console.log(error)
        //this.widgetBodyTarget.innerHTML = ""
        this.xhr_loading_animation.broken()
        this.awaiting_response = false
      })
  }

  fold(e) {
    e.preventDefault()
    if (!this.awaiting_response) {
      if (this.element.dataset.fold === 'false') {
        this.load()
        this.widgetBodyTarget.style.display = "block"
        this.foldLinkTarget.innerText = '[➖]'
        this.element.dataset.fold = 'true'
      } else {
        this.widgetBodyTarget.style.display = "none"
        this.foldLinkTarget.innerText = '[➕]'
        this.element.dataset.fold = 'false'
      }
      axios.post(`/widgets/${this.element.dataset.id}/fold`)
    }
  }

}